import { NumberInputProps, TextInput } from 'react-admin';
import { InputAdornment } from '@mui/material';

const SignedPercentNumberInput = (props: NumberInputProps) => {
  const { min = -100, max = 100, ...restProps } = props;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (['+', 'e', 'E'].includes(event.key)) {
      event.preventDefault();
    }
    if (props.onKeyDown) {
      props.onKeyDown(event);
    }
  };

  return (
    <TextInput
      type="number"
      min={min}
      max={max}
      sx={{ width: '16em' }}
      {...restProps}
      onKeyDown={handleKeyDown}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" sx={{ '& .MuiTypography-root': { fontSize: '14px', paddingRight: '14px' } }}>
            %
          </InputAdornment>
        ),
        inputProps: {
          min: min,
          max: max,
          step: 0.01,
        }
      }}
    />
  );
};

export default SignedPercentNumberInput;
